module.exports = __webpack_public_path__ + "5b3c71a26340414416972f4412fa511b.jpg";